/*
  samples-cart-reload.js
  ─────────────────────────────────────────────────────────────────────────────
  Free Sample Pack PDP (/products/free-samples, product 6922214080595).

  Problem: after an AJAX add, the "Ship My Free Sample Pack" button stays lit
  and clickable until a manual refresh — the inline guard in main-product.liquid
  only re-checks the cart on events the theme doesn't reliably fire after the
  add, so a shopper can keep clicking and add multiple packs.

  Why this lives here (not in main-product.liquid): that section file is ~380 KB,
  over Shopify's 256 KB per-file template limit, so the CLI can't push edits to
  it. theme.liquid is under the limit and loads this asset globally; the script
  self-gates to the samples PDP and no-ops everywhere else.

  Behavior: when an ALIVE add button is clicked, poll /cart.js; once the pack
  actually lands, flag + reload. On the reloaded page the existing inline guard
  disables the button (it re-checks the cart on a fresh load), and this script
  opens the cart slideout. A click that does NOT add (e.g. validation failure)
  never reloads — the pack never appears, so the poll just times out.
*/
(function () {
  var body = document.body;
  if (!body || !/(?:^|\s)template-product-samples(?:\s|$)/.test(body.className)) return;

  var SAMPLES_PRODUCT_ID = 6922214080595;
  var BUTTON_SELECTOR = '.product__cart-functions .add-to-cart[data-main-product-add-to-cart]';
  var RELOAD_FLAG = 'nt_samples_added_open_cart';

  function isSamplesInCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        return Array.isArray(c.items) && c.items.some(function (i) {
          return Number(i.product_id) === SAMPLES_PRODUCT_ID;
        });
      })
      .catch(function () { return false; });
  }

  /* ── On add: poll until the pack lands, then flag + reload ───────────────── */
  var watching = false;
  function watchThenReload() {
    if (watching) return;
    watching = true;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      isSamplesInCart().then(function (inCart) {
        if (inCart) {
          clearInterval(iv);
          try { sessionStorage.setItem(RELOAD_FLAG, '1'); } catch (e) {}
          window.location.reload();
        } else if (tries >= 24) { /* ~6s — add never landed; let normal flow continue */
          clearInterval(iv);
          watching = false;
        }
      });
    }, 250);
  }

  /* Delegated (capture) so it survives the button mounting late / re-renders.
     Only start watching for an ALIVE button — a dead/guarded one can't add. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(BUTTON_SELECTOR);
    if (!btn) return;
    if (btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true' || btn.dataset.samplesGuard) return;
    watchThenReload();
  }, true);

  /* ── On the reloaded page: open the cart slideout ────────────────────────── */
  function openCart() {
    var handle = document.querySelector('[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]');
    if (handle) { handle.click(); return true; }
    return false;
  }
  function maybeOpenCart() {
    var flagged = null;
    try { flagged = sessionStorage.getItem(RELOAD_FLAG); } catch (e) {}
    if (!flagged) return;
    try { sessionStorage.removeItem(RELOAD_FLAG); } catch (e) {}
    if (!openCart()) {
      var t = 0;
      var iv = setInterval(function () { if (openCart() || ++t > 25) clearInterval(iv); }, 200);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maybeOpenCart);
  else maybeOpenCart();
})();
